import { PropsWithChildren } from 'react';

import { Typography, Stack, tokens } from '@cast/design-system';

type QuickSearchGroupProps = PropsWithChildren<{
  label: string;
}>;

export const QuickSearchGroup = ({
  label,
  children,
}: QuickSearchGroupProps) => {
  const testId = `quick-search-group-${label
    .toLowerCase()
    .replace(/\s+/g, '-')}`;
  return (
    <Stack data-testid={testId}>
      <Typography
        variant="L10B"
        color={tokens.theme.fg.structural.secondary}
        sx={{ textTransform: 'uppercase', mb: 4 }}
        fontSize={8}
      >
        {label}:
      </Typography>
      <Stack direction="row" gap={8} flexWrap="wrap" alignItems="center">
        {children}
      </Stack>
    </Stack>
  );
};
